import { render, staticRenderFns } from "./RecreationCategories.vue?vue&type=template&id=1ac5c40a&scoped=true"
import script from "./RecreationCategories.vue?vue&type=script&lang=js"
export * from "./RecreationCategories.vue?vue&type=script&lang=js"
import style0 from "./RecreationCategories.vue?vue&type=style&index=0&id=1ac5c40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../CitizenPortalUI_Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac5c40a",
  null
  
)

export default component.exports